// import React, { useState } from "react";
// import { FiChevronRight, FiCheckCircle } from "react-icons/fi";
// import {
//   MdBusiness, MdSecurity, MdPerson, MdArrowForward
// } from "react-icons/md";

// /* ─── shared primitives (same pattern as Services page) ─── */
// const Breadcrumb = ({ items }) => (
//   <nav className="flex flex-wrap items-center gap-2 text-sm text-[#9a734c] mb-8">
//     {items.map((item, i) => (
//       <span key={i} className="flex items-center gap-2">
//         {i > 0 && <FiChevronRight className="text-[14px]" />}
//         {item.href
//           ? <a className="hover:text-primary hover:underline" href={item.href}>{item.label}</a>
//           : <span className="text-slate-900 dark:text-white">{item.label}</span>}
//       </span>
//     ))}
//   </nav>
// );

// const SectionHeading = ({ icon, label, id, color = "primary/10 text-primary" }) => (
//   <div className="flex items-center gap-3 mb-4">
//     <div className={`w-8 h-8 rounded bg-${color} flex items-center justify-center`}>
//       {icon}
//     </div>
//     <h2 id={id} className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white scroll-mt-24">
//       {label}
//     </h2>
//   </div>
// );

// const SubHeading = ({ children }) => (
//   <h3 className="text-lg font-bold text-slate-900 dark:text-white mt-2">{children}</h3>
// );

// const StepItem = ({ num, children }) => (
//   <li className="flex gap-3 items-start">
//     <span className="mt-0.5 min-w-[1.5rem] h-6 w-6 rounded-full bg-primary/10 text-primary text-xs font-bold flex items-center justify-center">{num}</span>
//     <span className="text-slate-600 dark:text-slate-400 leading-relaxed">{children}</span>
//   </li>
// );

// const BulletItem = ({ children }) => (
//   <li className="flex gap-2 items-start text-slate-600 dark:text-slate-400 leading-relaxed">
//     <span className="mt-2 w-1.5 h-1.5 rounded-full bg-primary shrink-0"></span>
//     <span>{children}</span>
//   </li>
// );

// const FieldRow = ({ field, description }) => (
//   <div className="flex gap-4 px-5 py-3.5 bg-white dark:bg-slate-900 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
//     <span className="min-w-[160px] text-sm font-semibold text-primary">{field}</span>
//     <span className="text-sm text-slate-600 dark:text-slate-400">{description}</span>
//   </div>
// );

// const NoteBox = ({ tone = "amber", title, children }) => {
//   const tones = {
//     amber: "bg-amber-50 dark:bg-amber-950/20 border-amber-200 dark:border-amber-800 text-amber-800 dark:text-amber-300",
//     slate: "bg-slate-50 dark:bg-slate-800/50 border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400",
//   };
//   return (
//     <div className={`rounded-xl p-5 border ${tones[tone]}`}>
//       {title && <p className="text-sm font-semibold mb-1">{title}</p>}
//       <div className="text-sm leading-relaxed">{children}</div>
//     </div>
//   );
// };

// /* ─── pipeline strip: the 6-step onboarding flow ─── */
// const PIPELINE = [
//   "Create Client", "Create Role", "Configure Products & Permissions",
//   "Create User", "Assign Client and Role", "User Login"
// ];

// const PipelineStrip = () => (
//   <div className="flex flex-wrap items-center gap-2">
//     {PIPELINE.map((step, i) => (
//       <React.Fragment key={step}>
//         <span className="px-3 py-1.5 rounded-full text-xs font-semibold bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-slate-700">
//           {step}
//         </span>
//         {i < PIPELINE.length - 1 && <MdArrowForward className="text-slate-300 dark:text-slate-600 text-sm" />}
//       </React.Fragment>
//     ))}
//   </div>
// );

// const TABS = ["Client", "Role", "User"];

// export function renderAdminOnboardingGuide() {
//   return <AdminOnboardingGuide />;
// }

// function AdminOnboardingGuide() {
//   const [activeTab, setActiveTab] = useState("Client");

//   return (
//     <main className="space-y-10">
//       <Breadcrumb items={[
//         { label: "Netraa APM" },
//         { label: "Admin Configuration" },
//         { label: "Client → Role → User Configuration Guide" },
//       ]} />

//       <div className="border-b border-gray-200 dark:border-gray-800 pb-6 mb-2 space-y-4">
//         <h1 className="text-3xl lg:text-5xl font-extrabold text-text-main dark:text-white tracking-tight leading-tight max-w-[800px]">
//           <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
//             Netraa APM Administration Guide:
//           </span>{" "}
//           Client → Role → User Configuration
//         </h1>
//         <p className="text-lg text-slate-500 dark:text-slate-400 leading-relaxed font-light max-w-[900px]">
//           This guide explains the complete administrator module for on-boarding a new organization into Netraa APM
//           to Configuring its resources to the provided license.
//         </p>
//         <PipelineStrip />
//       </div>

//       {/* Tab strip */}
//       <div className="flex flex-wrap gap-2">
//         {TABS.map(tab => (
//           <button
//             key={tab}
//             onClick={() => setActiveTab(tab)}
//             className={`inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full text-xs font-semibold border transition-all duration-200
//               ${activeTab === tab
//                 ? "bg-primary text-white border-primary shadow-sm shadow-primary/30"
//                 : "bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-700 hover:border-primary/50 hover:text-primary dark:hover:text-primary"
//               }`}
//           >
//             {tab === "Client" && <MdBusiness className="text-sm" />}
//             {tab === "Role" && <MdSecurity className="text-sm" />}
//             {tab === "User" && <MdPerson className="text-sm" />}
//             {tab}
//           </button>
//         ))}
//       </div>

//       {/* ══════════════ STEP 1 – CREATE CLIENT ══════════════ */}
//       {activeTab === "Client" && (
//         <section className="space-y-6" style={{ animation: "fadeIn 0.3s ease" }} id="client">
//           <SectionHeading icon={<MdBusiness className="text-xl" />} label="Step 1 – Create Client" id="create-client" />

//           <SubHeading>Overview</SubHeading>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             The Client represents an organization (tenant) within Netraa APM. Creating a client is the first step in the
//             on-boarding process and forms the foundation for all subsequent configurations, including license allocation,
//             role creation, and user management.
//           </p>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             Each client maintains its own data retention policy, contact information, licenses, and access permissions,
//             ensuring complete isolation between organizations.
//           </p>

//           <SubHeading>Prerequisites</SubHeading>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             Before creating a client, ensure the following information is available:
//           </p>
//           <ul className="space-y-2">
//             <BulletItem>Administrator access to Netraa APM</BulletItem>
//             <BulletItem>Client Name</BulletItem>
//             <BulletItem>Domain</BulletItem>
//             <BulletItem>Client Status (Active/Inactive)</BulletItem>
//             <BulletItem>Data Retention Period</BulletItem>
//             <BulletItem>Time Unit (Days / Months / Years)</BulletItem>
//             <BulletItem>Primary Contact Name</BulletItem>
//             <BulletItem>Contact Number</BulletItem>
//             <BulletItem>Email Address</BulletItem>
//             <BulletItem>Licensing model (if applicable)</BulletItem>
//           </ul>

//           <NoteBox tone="slate" title="Navigation">
//             Navigate to: Admin Configuration → Client → Add Client
//           </NoteBox>

//           <SubHeading>Procedure</SubHeading>

//           <p className="font-semibold text-slate-800 dark:text-slate-200">Step 1 – Open Client</p>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             Log in to Netraa APM using an administrator account and navigate to: Admin Configuration → Client.
//             Click Add Client to open the Client Creation page.
//           </p>

//           <p className="font-semibold text-slate-800 dark:text-slate-200">Step 2 – Enter Client Information</p>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             In the Client Information section, provide the following details:
//           </p>
//           <div className="divide-y divide-slate-100 dark:divide-slate-800 rounded-xl border border-slate-200 dark:border-slate-800 overflow-hidden">
//             <FieldRow field="Client Name" description="Unique name of the organization or tenant" />
//             <FieldRow field="Domain" description="Select the client's business domain" />
//             <FieldRow field="Status" description="Choose Active or Inactive" />
//           </div>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             These details uniquely identify the organization within the Netraa APM platform.
//           </p>

//           <p className="font-semibold text-slate-800 dark:text-slate-200">Step 3 – Configure Data Retention</p>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             In the Retention Details section, configure how long monitoring data should be retained.
//           </p>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">Provide:</p>
//           <ul className="space-y-2">
//             <BulletItem>Retention Period</BulletItem>
//             <BulletItem>Time Unit (Days, Months, or Years)</BulletItem>
//           </ul>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             This determines the duration for which logs, metrics, and monitoring data are stored before automatic cleanup.
//           </p>

//           <p className="font-semibold text-slate-800 dark:text-slate-200">Step 4 – Add Company Contact Details</p>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             Provide the primary contact information for the client.
//           </p>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">Enter:</p>
//           <ul className="space-y-2">
//             <BulletItem>Contact Name</BulletItem>
//             <BulletItem>Mobile Number</BulletItem>
//             <BulletItem>Email Address</BulletItem>
//           </ul>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             Multiple contacts can be added using the Add Contact button if required.
//           </p>

//           <p className="font-semibold text-slate-800 dark:text-slate-200">Step 5 – Save the Client</p>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             Review all the entered information carefully. Click Save Client. Upon successful validation, the system
//             creates the client and makes it available for:
//           </p>
//           <ul className="space-y-2">
//             <BulletItem>License Management</BulletItem>
//             <BulletItem>Role Assignment</BulletItem>
//             <BulletItem>User Mapping</BulletItem>
//             <BulletItem>Monitoring Configuration</BulletItem>
//           </ul>

//           <SubHeading>Validation Rules</SubHeading>
//           <ul className="grid sm:grid-cols-2 gap-2">
//             {[
//               "Client Name must be unique.",
//               "Mandatory fields cannot be left blank.",
//               "Email address must be valid.",
//               "Contact Number should contain only numeric values.",
//               "Retention Period must be greater than zero.",
//             ].map(v => (
//               <li key={v} className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400">
//                 <FiCheckCircle className="text-primary shrink-0" /> {v}
//               </li>
//             ))}
//           </ul>

//           <SubHeading>Notes</SubHeading>
//           <ul className="space-y-2">
//             <BulletItem>A Client must be created before licenses can be generated.</BulletItem>
//             <BulletItem>Roles and users cannot be assigned until a client exists.</BulletItem>
//             <BulletItem>Review all information carefully before saving.</BulletItem>
//             <BulletItem>Client information can be modified later by users with appropriate administrative privileges.</BulletItem>
//           </ul>

//           <SubHeading>Expected Result</SubHeading>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">After successfully saving:</p>
//           <ul className="space-y-2">
//             <BulletItem>The new client appears in the Client Management list.</BulletItem>
//             <BulletItem>The client becomes available for License Generation.</BulletItem>
//             <BulletItem>Roles can be associated with the client.</BulletItem>
//             <BulletItem>Users can later be assigned to this client during User Creation.</BulletItem>
//             <BulletItem>The client is ready for complete RBAC configuration.</BulletItem>
//           </ul>
//         </section>
//       )}

//       {/* ══════════════ STEP 2 – CREATE ROLE ══════════════ */}
//       {activeTab === "Role" && (
//         <section className="space-y-6" style={{ animation: "fadeIn 0.3s ease" }} id="role">
//           <SectionHeading icon={<MdSecurity className="text-xl" />} label="Step 2 – Create Role" id="create-role" />

//           <SubHeading>Overview</SubHeading>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             A Role defines the permissions and access boundaries for users within the Netraa APM platform. It determines
//             which monitoring products, dashboards, applications, infrastructure resources, and administrative features
//             a user can access after successfully logging in.
//           </p>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             Creating a role is the second step in the Role-Based Access Control (RBAC) configuration process. Once
//             created, a role can be assigned to one or more users, ensuring consistent access control across the
//             organization.
//           </p>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             A role can be configured to provide access to specific monitoring products, features, technologies,
//             applications, hosts, databases, services, and infrastructure components based on organizational
//             requirements.
//           </p>

//           <SubHeading>Prerequisites</SubHeading>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             Before creating a role, ensure the following prerequisites are met:
//           </p>
//           <ul className="space-y-2">
//             <BulletItem>Administrator access to Netraa APM</BulletItem>
//             <BulletItem>A unique Role Name</BulletItem>
//             <BulletItem>A meaningful Description explaining the role's purpose</BulletItem>
//             <BulletItem>Knowledge of the monitoring products that need to be assigned</BulletItem>
//             <BulletItem>Knowledge of the features and resources the users should access</BulletItem>
//           </ul>

//           <NoteBox tone="slate" title="Navigation">
//             Navigate to: Admin Configuration → Role → Add Role
//           </NoteBox>

//           <SubHeading>Procedure</SubHeading>

//           <p className="font-semibold text-slate-800 dark:text-slate-200">Step 1: Open Role Management</p>
//           <ol className="space-y-3">
//             <StepItem num={1}>Log in to Netraa APM using an administrator account.</StepItem>
//             <StepItem num={2}>Navigate to Admin Configuration.</StepItem>
//             <StepItem num={3}>Select Role from the navigation menu.</StepItem>
//             <StepItem num={4}>Click Create New Role.</StepItem>
//           </ol>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">The Role Creation page is displayed.</p>

//           <p className="font-semibold text-slate-800 dark:text-slate-200">Step 2: Enter Role Information</p>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             Enter the basic information for the new role.
//           </p>
//           <div className="divide-y divide-slate-100 dark:divide-slate-800 rounded-xl border border-slate-200 dark:border-slate-800 overflow-hidden">
//             <FieldRow field="Role Name" description="Enter a unique name that identifies the role." />
//             <FieldRow field="Description" description="Provide a brief description explaining the responsibilities of the role." />
//           </div>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             These details help administrators identify the appropriate role during user assignment.
//           </p>

//           <p className="font-semibold text-slate-800 dark:text-slate-200">Step 3: Assign Monitoring Products</p>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             Select the monitoring products that users assigned to this role should be able to access. Examples include:
//           </p>
//           <ul className="space-y-2">
//             <BulletItem>Infrastructure Monitoring</BulletItem>
//             <BulletItem>Application Performance Monitoring (APM)</BulletItem>
//             <BulletItem>Database Monitoring</BulletItem>
//             <BulletItem>Cloud Monitoring</BulletItem>
//             <BulletItem>Network Monitoring</BulletItem>
//             <BulletItem>Real User Monitoring (RUM)</BulletItem>
//             <BulletItem>Browser RUM</BulletItem>
//             <BulletItem>Messaging Platforms</BulletItem>
//           </ul>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             Move the required products from the Available Products panel to the Assigned Products panel.
//           </p>

//           <p className="font-semibold text-slate-800 dark:text-slate-200">Step 4: Assign Feature Components</p>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             After assigning monitoring products, select the required feature components. Feature Components determine
//             which functional areas of the application are visible to the user. Examples include:
//           </p>
//           <ul className="space-y-2">
//             <BulletItem>Dashboards</BulletItem>
//             <BulletItem>Reports</BulletItem>
//             <BulletItem>Alerts</BulletItem>
//             <BulletItem>Transactions</BulletItem>
//             <BulletItem>Metrics</BulletItem>
//             <BulletItem>Administration</BulletItem>
//             <BulletItem>Discovery</BulletItem>
//             <BulletItem>Analytics</BulletItem>
//           </ul>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             Only the assigned feature components will appear in the user's navigation menu after login.
//           </p>

//           <p className="font-semibold text-slate-800 dark:text-slate-200">Step 5: Configure Resource Permissions</p>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             Configure access to infrastructure resources. Depending on the selected monitoring products, assign
//             permissions for:
//           </p>
//           <ul className="space-y-2">
//             <BulletItem>Hosts</BulletItem>
//             <BulletItem>Services</BulletItem>
//             <BulletItem>Applications</BulletItem>
//             <BulletItem>Databases</BulletItem>
//             <BulletItem>API Gateways</BulletItem>
//             <BulletItem>Kubernetes Clusters</BulletItem>
//             <BulletItem>Kafka</BulletItem>
//             <BulletItem>Redis</BulletItem>
//             <BulletItem>RabbitMQ</BulletItem>
//             <BulletItem>IIS</BulletItem>
//             <BulletItem>Nginx</BulletItem>
//             <BulletItem>Other monitored resources</BulletItem>
//           </ul>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             Use the available filters such as Technology Type, Operating System, Database Type, or Application Type to
//             locate the required resources quickly. Select the required resources and move them to the Assigned section.
//           </p>

//           <p className="font-semibold text-slate-800 dark:text-slate-200">Step 6: Save the Role</p>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             Review all assigned products, features, and resource permissions. Click Save Role. The system validates
//             the configuration and creates the new role.
//           </p>

//           <SubHeading>Validation Rules</SubHeading>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             The following validations are performed before saving:
//           </p>
//           <ul className="grid sm:grid-cols-2 gap-2">
//             {[
//               "Role Name must be unique.",
//               "Role Name is mandatory.",
//               "At least one monitoring product should be assigned.",
//               "Duplicate resource assignments are not permitted.",
//               "Assigned resources must belong to the selected technology.",
//             ].map(v => (
//               <li key={v} className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400">
//                 <FiCheckCircle className="text-primary shrink-0" /> {v}
//               </li>
//             ))}
//           </ul>

//           <SubHeading>Notes</SubHeading>
//           <NoteBox tone="amber" title="Important">A single role can be assigned to multiple users.</NoteBox>
//           <NoteBox tone="slate" title="Recommendation">
//             Grant only the permissions required to perform the user's responsibilities. Following the Principle of
//             Least Privilege improves system security.
//           </NoteBox>
//           <NoteBox tone="slate" title="Note">
//             Any modifications made to an existing role automatically affect all users assigned to that role after
//             their next login.
//           </NoteBox>

//           <SubHeading>Expected Result</SubHeading>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">After successfully saving the role:</p>
//           <ul className="space-y-2">
//             <BulletItem>The role is displayed in the Role Management list.</BulletItem>
//             <BulletItem>Assigned monitoring products are saved.</BulletItem>
//             <BulletItem>Feature permissions are stored.</BulletItem>
//             <BulletItem>Resource mappings are associated with the role.</BulletItem>
//             <BulletItem>The role becomes available during User Creation.</BulletItem>
//           </ul>

//           <SubHeading>Next Step</SubHeading>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             Proceed to Step 3 – Create User to assign the newly created role to a user.
//           </p>
//         </section>
//       )}

//       {/* ══════════════ STEP 3 – CREATE USER ══════════════ */}
//       {activeTab === "User" && (
//         <section className="space-y-6" style={{ animation: "fadeIn 0.3s ease" }} id="user">
//           <SectionHeading icon={<MdPerson className="text-xl" />} label="Step 3 – Create User" id="create-user" />

//           <SubHeading>Overview</SubHeading>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             A User represents an individual who is authorized to access the Netraa APM platform.
//           </p>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             User creation is the final step in the RBAC configuration process. During this step, the administrator
//             associates the user with both a Client and a Role.
//           </p>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             The assigned Client determines the organizational context (tenant) to which the user belongs, while the
//             assigned Role determines the user's permissions, navigation menu, monitoring products, dashboards, and
//             resource visibility.
//           </p>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             Only after both the Client and Role are assigned can a user successfully access the platform with the
//             intended permissions.
//           </p>

//           <SubHeading>Prerequisites</SubHeading>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             Before creating a user, ensure the following have already been completed:
//           </p>
//           <ul className="space-y-2">
//             <BulletItem>Client has been created.</BulletItem>
//             <BulletItem>Role has been created.</BulletItem>
//             <BulletItem>Administrator access is available.</BulletItem>
//             <BulletItem>User information has been collected.</BulletItem>
//           </ul>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">Required information includes:</p>
//           <ul className="space-y-2">
//             <BulletItem>Username</BulletItem>
//             <BulletItem>Full Name</BulletItem>
//             <BulletItem>Email Address</BulletItem>
//             <BulletItem>Mobile Number</BulletItem>
//             <BulletItem>Authentication Type</BulletItem>
//             <BulletItem>User Type</BulletItem>
//           </ul>

//           <NoteBox tone="slate" title="Navigation">
//             Navigate to: Admin Configuration → User Management → Add User
//           </NoteBox>

//           <SubHeading>Procedure</SubHeading>

//           <p className="font-semibold text-slate-800 dark:text-slate-200">Step 1: Open User Management</p>
//           <ol className="space-y-3">
//             <StepItem num={1}>Log in to Netraa APM using an administrator account.</StepItem>
//             <StepItem num={2}>Navigate to Admin Configuration.</StepItem>
//             <StepItem num={3}>Select User Management.</StepItem>
//             <StepItem num={4}>Click Create User.</StepItem>
//           </ol>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">The User Creation page opens.</p>

//           <p className="font-semibold text-slate-800 dark:text-slate-200">Step 2: Enter User Information</p>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             Provide the user's personal information.
//           </p>
//           <div className="divide-y divide-slate-100 dark:divide-slate-800 rounded-xl border border-slate-200 dark:border-slate-800 overflow-hidden">
//             <FieldRow field="Username" description="Unique login ID used to access Netraa APM" />
//             <FieldRow field="Full Name" description="User's display name" />
//             <FieldRow field="Email Address" description="Used for notifications and password recovery" />
//             <FieldRow field="Mobile Number" description="Contact number" />
//             <FieldRow field="Description" description="Optional information about the user" />
//           </div>

//           <p className="font-semibold text-slate-800 dark:text-slate-200">Step 3: Configure Account Settings</p>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             Configure the authentication settings. Select:
//           </p>
//           <ul className="space-y-2">
//             <BulletItem>Authentication Type</BulletItem>
//             <BulletItem>User Type</BulletItem>
//             <BulletItem>Account Status</BulletItem>
//           </ul>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             These settings determine how the user authenticates and whether the account is active.
//           </p>

//           <p className="font-semibold text-slate-800 dark:text-slate-200">Step 4: Assign Client and Role</p>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             This is the most important step of the configuration process. Select the appropriate Client. Once a Client
//             is selected, the system automatically filters and displays the Roles available for that Client. Next,
//             select the required Role. The selected Role determines:
//           </p>
//           <ul className="space-y-2">
//             <BulletItem>Accessible dashboards</BulletItem>
//             <BulletItem>Monitoring products</BulletItem>
//             <BulletItem>Feature components</BulletItem>
//             <BulletItem>Infrastructure resources</BulletItem>
//             <BulletItem>Applications</BulletItem>
//             <BulletItem>Hosts</BulletItem>
//             <BulletItem>Services</BulletItem>
//             <BulletItem>Databases</BulletItem>
//             <BulletItem>Administrative permissions</BulletItem>
//           </ul>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             Configure the session timeout value if required.
//           </p>

//           <p className="font-semibold text-slate-800 dark:text-slate-200">Step 5: Save the User</p>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             Review all entered information. Click Create User. The system validates the configuration and creates the
//             user account.
//           </p>

//           <SubHeading>Validation Rules</SubHeading>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             The following validations are performed before saving:
//           </p>
//           <ul className="grid sm:grid-cols-2 gap-2">
//             {[
//               "Username must be unique.",
//               "Client selection is mandatory.",
//               "Role selection is mandatory.",
//               "Email must be valid.",
//               "Mobile Number must contain only numeric values.",
//               "Mandatory fields cannot be left blank.",
//             ].map(v => (
//               <li key={v} className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400">
//                 <FiCheckCircle className="text-primary shrink-0" /> {v}
//               </li>
//             ))}
//           </ul>

//           <SubHeading>Notes</SubHeading>
//           <NoteBox tone="amber" title="Important">A user cannot exist without a Client assignment.</NoteBox>
//           <NoteBox tone="amber" title="Important">A user's permissions are inherited entirely from the assigned Role.</NoteBox>
//           <NoteBox tone="slate" title="Recommendation">
//             Assign only the minimum permissions required for the user's responsibilities.
//           </NoteBox>

//           <SubHeading>Expected Result</SubHeading>
//           <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
//             After successfully creating the user:
//           </p>
//           <ul className="space-y-2">
//             <BulletItem>The user appears in the User Management page.</BulletItem>
//             <BulletItem>The account becomes active.</BulletItem>
//             <BulletItem>The user can authenticate using the configured credentials.</BulletItem>
//             <BulletItem>The navigation menu is generated dynamically according to the assigned Role.</BulletItem>
//             <BulletItem>Access to monitoring data is restricted to the assigned Client.</BulletItem>
//             <BulletItem>Resource visibility is controlled according to the configured Role permissions.</BulletItem>
//           </ul>
//         </section>
//       )}

//       <style>{`
//         @keyframes fadeIn {
//           from { opacity: 0; transform: translateY(8px); }
//           to   { opacity: 1; transform: translateY(0); }
//         }
//       `}</style>
//     </main>
//   );
// }

// export default AdminOnboardingGuide;

import React, { useState } from "react";
import { FiChevronRight, FiCheckCircle } from "react-icons/fi";
import {
  MdBusiness, MdSecurity, MdPerson, MdArrowForward
} from "react-icons/md";

/* ─── step / result images ───
   Replace these paths with your actual asset files. */
import clientResultImg from "../../assets/client.png";

import roleStep1Img from "../../assets/role.png";
import roleStep2Img from "../../assets/role2.png";
import roleStep3Img from "../../assets/role3.png";
import roleStep4Img from "../../assets/role4.png";
import roleStep5Img from "../../assets/role5.png";
import roleStep6Img from "../../assets/role6.png";

import userStep1Img from "../../assets/user.png";
import userStep3Img from "../../assets/user2.png";
import userStep5Img from "../../assets/user3.png";

/* ─── shared primitives (same pattern as Services page) ─── */
const Breadcrumb = ({ items }) => (
  <nav className="flex flex-wrap items-center gap-2 text-sm text-[#9a734c] mb-8">
    {items.map((item, i) => (
      <span key={i} className="flex items-center gap-2">
        {i > 0 && <FiChevronRight className="text-[14px]" />}
        {item.href
          ? <a className="hover:text-primary hover:underline" href={item.href}>{item.label}</a>
          : <span className="text-slate-900 dark:text-white">{item.label}</span>}
      </span>
    ))}
  </nav>
);

const SectionHeading = ({ icon, label, id, color = "primary/10 text-primary" }) => (
  <div className="flex items-center gap-3 mb-4">
    <div className={`w-8 h-8 rounded bg-${color} flex items-center justify-center`}>
      {icon}
    </div>
    <h2 id={id} className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white scroll-mt-24">
      {label}
    </h2>
  </div>
);

const SubHeading = ({ children }) => (
  <h3 className="text-lg font-bold text-slate-900 dark:text-white mt-2">{children}</h3>
);

const StepItem = ({ num, children }) => (
  <li className="flex gap-3 items-start">
    <span className="mt-0.5 min-w-[1.5rem] h-6 w-6 rounded-full bg-primary/10 text-primary text-xs font-bold flex items-center justify-center">{num}</span>
    <span className="text-slate-600 dark:text-slate-400 leading-relaxed">{children}</span>
  </li>
);

const BulletItem = ({ children }) => (
  <li className="flex gap-2 items-start text-slate-600 dark:text-slate-400 leading-relaxed">
    <span className="mt-2 w-1.5 h-1.5 rounded-full bg-primary shrink-0"></span>
    <span>{children}</span>
  </li>
);

const FieldRow = ({ field, description }) => (
  <div className="flex gap-4 px-5 py-3.5 bg-white dark:bg-slate-900 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
    <span className="min-w-[160px] text-sm font-semibold text-primary">{field}</span>
    <span className="text-sm text-slate-600 dark:text-slate-400">{description}</span>
  </div>
);

const NoteBox = ({ tone = "amber", title, children }) => {
  const tones = {
    amber: "bg-amber-50 dark:bg-amber-950/20 border-amber-200 dark:border-amber-800 text-amber-800 dark:text-amber-300",
    slate: "bg-slate-50 dark:bg-slate-800/50 border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400",
  };
  return (
    <div className={`rounded-xl p-5 border ${tones[tone]}`}>
      {title && <p className="text-sm font-semibold mb-1">{title}</p>}
      <div className="text-sm leading-relaxed">{children}</div>
    </div>
  );
};

const StepImage = ({ src, alt }) => (
  <img
    src={src}
    alt={alt}
    className="mt-2 rounded-lg border border-slate-200 dark:border-white/10 shadow-md"
  />
);

/* ─── pipeline strip: the 6-step onboarding flow ─── */
const PIPELINE = [
  "Create Client", "Create Role", "Configure Products & Permissions",
  "Create User", "Assign Client and Role", "User Login"
];

const PipelineStrip = () => (
  <div className="flex flex-wrap items-center gap-2">
    {PIPELINE.map((step, i) => (
      <React.Fragment key={step}>
        <span className="px-3 py-1.5 rounded-full text-xs font-semibold bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-slate-700">
          {step}
        </span>
        {i < PIPELINE.length - 1 && <MdArrowForward className="text-slate-300 dark:text-slate-600 text-sm" />}
      </React.Fragment>
    ))}
  </div>
);

const TABS = [
  { key: "Client", icon: MdBusiness },
  { key: "Role", icon: MdSecurity },
  { key: "User", icon: MdPerson },
];

export function renderAdminOnboardingGuide() {
  return <AdminOnboardingGuide />;
}

function AdminOnboardingGuide() {
  // null = Show All (every section rendered in order)
  const [activeTab, setActiveTab] = useState(null);

  const handleTabClick = (tab) => {
    setActiveTab(tab === activeTab ? null : tab);
  };

  const showSection = (tab) => activeTab === null || activeTab === tab;

  return (
    <main className="space-y-10">
      <Breadcrumb items={[
        { label: "Netraa APM" },
        { label: "Analyze & Explore" },
        { label: "Apps" },
        { label: "Configuration" },
        { label: "Admin-Config" },
      ]} />

      <div className="border-b border-gray-200 dark:border-gray-800 pb-6 mb-2 space-y-4">
        <h1 className="text-3xl lg:text-5xl font-extrabold text-text-main dark:text-white tracking-tight leading-tight max-w-[800px]">
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
            Netraa APM Administration Guide:
          </span>{" "}
          Configuration
        </h1>
        <p className="text-lg text-slate-500 dark:text-slate-400 leading-relaxed font-light max-w-[900px]">
          This guide explains the complete administrator module for on-boarding a new organization into Netraa APM
          to Configuring its resources to the provided license.
        </p>
        <PipelineStrip />
      </div>

      {/* Tab strip */}
      <div className="flex flex-wrap gap-2">
        {TABS.map(({ key, icon: Icon }) => (
          <button
            key={key}
            onClick={() => handleTabClick(key)}
            className={`inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full text-xs font-semibold border transition-all duration-200
              ${activeTab === key
                ? "bg-primary text-white border-primary shadow-sm shadow-primary/30"
                : "bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-700 hover:border-primary/50 hover:text-primary dark:hover:text-primary"
              }`}
          >
            <Icon className="text-sm" />
            {key}
          </button>
        ))}

        {/* Show All button — only visible when a tab is active */}
        {activeTab !== null && (
          <button
            onClick={() => setActiveTab(null)}
            className="inline-flex items-center px-4 py-1.5 rounded-full text-xs font-semibold border border-dashed border-orange-400 text-orange-500 bg-orange-50 dark:bg-orange-950/20 hover:bg-orange-100 dark:hover:bg-orange-900/30 transition-all duration-200"
          >
            Show All
          </button>
        )}
      </div>

      {/* ══════════════ STEP 1 – CREATE CLIENT ══════════════ */}
      {showSection("Client") && (
        <section className="space-y-6" style={{ animation: "fadeIn 0.3s ease" }} id="client">
          <SectionHeading icon={<MdBusiness className="text-xl" />} label="Step 1 – Create Client" id="create-client" />

          <SubHeading>Overview</SubHeading>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            The Client represents an organization (tenant) within Netraa APM. Creating a client is the first step in the
            on-boarding process and forms the foundation for all subsequent configurations, including license allocation,
            role creation, and user management.
          </p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            Each client maintains its own data retention policy, contact information, licenses, and access permissions,
            ensuring complete isolation between organizations.
          </p>

          <SubHeading>Prerequisites</SubHeading>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            Before creating a client, ensure the following information is available:
          </p>
          <ul className="space-y-2">
            <BulletItem>Administrator access to Netraa APM</BulletItem>
            <BulletItem>Client Name</BulletItem>
            <BulletItem>Domain</BulletItem>
            <BulletItem>Client Status (Active/Inactive)</BulletItem>
            <BulletItem>Data Retention Period</BulletItem>
            <BulletItem>Time Unit (Days / Months / Years)</BulletItem>
            <BulletItem>Primary Contact Name</BulletItem>
            <BulletItem>Contact Number</BulletItem>
            <BulletItem>Email Address</BulletItem>
            <BulletItem>Licensing model (if applicable)</BulletItem>
          </ul>

          <NoteBox tone="slate" title="Navigation">
            Navigate to: Admin Configuration → Client → Add Client
          </NoteBox>

          <SubHeading>Procedure</SubHeading>

          <p className="font-semibold text-slate-800 dark:text-slate-200">Step 1 – Open Client</p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            Log in to Netraa APM using an administrator account and navigate to: Admin Configuration → Client.
            Click Add Client to open the Client Creation page.
          </p>

          <p className="font-semibold text-slate-800 dark:text-slate-200">Step 2 – Enter Client Information</p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            In the Client Information section, provide the following details:
          </p>
          <div className="divide-y divide-slate-100 dark:divide-slate-800 rounded-xl border border-slate-200 dark:border-slate-800 overflow-hidden">
            <FieldRow field="Client Name" description="Unique name of the organization or tenant" />
            <FieldRow field="Domain" description="Select the client's business domain" />
            <FieldRow field="Status" description="Choose Active or Inactive" />
          </div>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            These details uniquely identify the organization within the Netraa APM platform.
          </p>

          <p className="font-semibold text-slate-800 dark:text-slate-200">Step 3 – Configure Data Retention</p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            In the Retention Details section, configure how long monitoring data should be retained.
          </p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">Provide:</p>
          <ul className="space-y-2">
            <BulletItem>Retention Period</BulletItem>
            <BulletItem>Time Unit (Days, Months, or Years)</BulletItem>
          </ul>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            This determines the duration for which logs, metrics, and monitoring data are stored before automatic cleanup.
          </p>

          <p className="font-semibold text-slate-800 dark:text-slate-200">Step 4 – Add Company Contact Details</p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            Provide the primary contact information for the client.
          </p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">Enter:</p>
          <ul className="space-y-2">
            <BulletItem>Contact Name</BulletItem>
            <BulletItem>Mobile Number</BulletItem>
            <BulletItem>Email Address</BulletItem>
          </ul>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            Multiple contacts can be added using the Add Contact button if required.
          </p>

          <p className="font-semibold text-slate-800 dark:text-slate-200">Step 5 – Save the Client</p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            Review all the entered information carefully. Click Save Client. Upon successful validation, the system
            creates the client and makes it available for:
          </p>
          <ul className="space-y-2">
            <BulletItem>License Management</BulletItem>
            <BulletItem>Role Assignment</BulletItem>
            <BulletItem>User Mapping</BulletItem>
            <BulletItem>Monitoring Configuration</BulletItem>
          </ul>

          <SubHeading>Validation Rules</SubHeading>
          <ul className="grid sm:grid-cols-2 gap-2">
            {[
              "Client Name must be unique.",
              "Mandatory fields cannot be left blank.",
              "Email address must be valid.",
              "Contact Number should contain only numeric values.",
              "Retention Period must be greater than zero.",
            ].map(v => (
              <li key={v} className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400">
                <FiCheckCircle className="text-primary shrink-0" /> {v}
              </li>
            ))}
          </ul>

          <SubHeading>Notes</SubHeading>
          <ul className="space-y-2">
            <BulletItem>A Client must be created before licenses can be generated.</BulletItem>
            <BulletItem>Roles and users cannot be assigned until a client exists.</BulletItem>
            <BulletItem>Review all information carefully before saving.</BulletItem>
            <BulletItem>Client information can be modified later by users with appropriate administrative privileges.</BulletItem>
          </ul>

          <SubHeading>Expected Result</SubHeading>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">After successfully saving:</p>
          <ul className="space-y-2">
            <BulletItem>The new client appears in the Client Management list.</BulletItem>
            <BulletItem>The client becomes available for License Generation.</BulletItem>
            <BulletItem>Roles can be associated with the client.</BulletItem>
            <BulletItem>Users can later be assigned to this client during User Creation.</BulletItem>
            <BulletItem>The client is ready for complete RBAC configuration.</BulletItem>
          </ul>
          <StepImage src={clientResultImg} alt="Client Expected Result" />
        </section>
      )}

      {/* ══════════════ STEP 2 – CREATE ROLE ══════════════ */}
      {showSection("Role") && (
        <section className="space-y-6" style={{ animation: "fadeIn 0.3s ease" }} id="role">
          <SectionHeading icon={<MdSecurity className="text-xl" />} label="Step 2 – Create Role" id="create-role" />

          <SubHeading>Overview</SubHeading>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            A Role defines the permissions and access boundaries for users within the Netraa APM platform. It determines
            which monitoring products, dashboards, applications, infrastructure resources, and administrative features
            a user can access after successfully logging in.
          </p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            Creating a role is the second step in the Role-Based Access Control (RBAC) configuration process. Once
            created, a role can be assigned to one or more users, ensuring consistent access control across the
            organization.
          </p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            A role can be configured to provide access to specific monitoring products, features, technologies,
            applications, hosts, databases, services, and infrastructure components based on organizational
            requirements.
          </p>

          <SubHeading>Prerequisites</SubHeading>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            Before creating a role, ensure the following prerequisites are met:
          </p>
          <ul className="space-y-2">
            <BulletItem>Administrator access to Netraa APM</BulletItem>
            <BulletItem>A unique Role Name</BulletItem>
            <BulletItem>A meaningful Description explaining the role's purpose</BulletItem>
            <BulletItem>Knowledge of the monitoring products that need to be assigned</BulletItem>
            <BulletItem>Knowledge of the features and resources the users should access</BulletItem>
          </ul>

          <NoteBox tone="slate" title="Navigation">
            Navigate to: Admin Configuration → Role → Add Role
          </NoteBox>

          <SubHeading>Procedure</SubHeading>

          <p className="font-semibold text-slate-800 dark:text-slate-200">Step 1: Open Role Management</p>
          <ol className="space-y-3">
            <StepItem num={1}>Log in to Netraa APM using an administrator account.</StepItem>
            <StepItem num={2}>Navigate to Admin Configuration.</StepItem>
            <StepItem num={3}>Select Role from the navigation menu.</StepItem>
            <StepItem num={4}>Click Create New Role.</StepItem>
          </ol>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">The Role Creation page is displayed.</p>
          <StepImage src={roleStep1Img} alt="Step 1 – Open Role Management" />

          <p className="font-semibold text-slate-800 dark:text-slate-200">Step 2: Enter Role Information</p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            Enter the basic information for the new role.
          </p>
          <div className="divide-y divide-slate-100 dark:divide-slate-800 rounded-xl border border-slate-200 dark:border-slate-800 overflow-hidden">
            <FieldRow field="Role Name" description="Enter a unique name that identifies the role." />
            <FieldRow field="Description" description="Provide a brief description explaining the responsibilities of the role." />
          </div>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            These details help administrators identify the appropriate role during user assignment.
          </p>
          <StepImage src={roleStep2Img} alt="Step 2 – Enter Role Information" />

          <p className="font-semibold text-slate-800 dark:text-slate-200">Step 3: Assign Monitoring Products</p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            Select the monitoring products that users assigned to this role should be able to access. Examples include:
          </p>
          <ul className="space-y-2">
            <BulletItem>Infrastructure Monitoring</BulletItem>
            <BulletItem>Application Performance Monitoring (APM)</BulletItem>
            <BulletItem>Database Monitoring</BulletItem>
            <BulletItem>Cloud Monitoring</BulletItem>
            <BulletItem>Network Monitoring</BulletItem>
            <BulletItem>Real User Monitoring (RUM)</BulletItem>
            <BulletItem>Browser RUM</BulletItem>
            <BulletItem>Messaging Platforms</BulletItem>
          </ul>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            Move the required products from the Available Products panel to the Assigned Products panel.
          </p>
          <StepImage src={roleStep3Img} alt="Step 3 – Assign Monitoring Products" />

          <p className="font-semibold text-slate-800 dark:text-slate-200">Step 4: Assign Feature Components</p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            After assigning monitoring products, select the required feature components. Feature Components determine
            which functional areas of the application are visible to the user. Examples include:
          </p>
          <ul className="space-y-2">
            <BulletItem>Dashboards</BulletItem>
            <BulletItem>Reports</BulletItem>
            <BulletItem>Alerts</BulletItem>
            <BulletItem>Transactions</BulletItem>
            <BulletItem>Metrics</BulletItem>
            <BulletItem>Administration</BulletItem>
            <BulletItem>Discovery</BulletItem>
            <BulletItem>Analytics</BulletItem>
          </ul>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            Only the assigned feature components will appear in the user's navigation menu after login.
          </p>
          <StepImage src={roleStep4Img} alt="Step 4 – Assign Feature Components" />

          <p className="font-semibold text-slate-800 dark:text-slate-200">Step 5: Configure Resource Permissions</p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            Configure access to infrastructure resources. Depending on the selected monitoring products, assign
            permissions for:
          </p>
          <ul className="space-y-2">
            <BulletItem>Hosts</BulletItem>
            <BulletItem>Services</BulletItem>
            <BulletItem>Applications</BulletItem>
            <BulletItem>Databases</BulletItem>
            <BulletItem>API Gateways</BulletItem>
            <BulletItem>Kubernetes Clusters</BulletItem>
            <BulletItem>Kafka</BulletItem>
            <BulletItem>Redis</BulletItem>
            <BulletItem>RabbitMQ</BulletItem>
            <BulletItem>IIS</BulletItem>
            <BulletItem>Nginx</BulletItem>
            <BulletItem>Other monitored resources</BulletItem>
          </ul>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            Use the available filters such as Technology Type, Operating System, Database Type, or Application Type to
            locate the required resources quickly. Select the required resources and move them to the Assigned section.
          </p>
          <StepImage src={roleStep5Img} alt="Step 5 – Configure Resource Permissions" />

          <p className="font-semibold text-slate-800 dark:text-slate-200">Step 6: Save the Role</p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            Review all assigned products, features, and resource permissions. Click Save Role. The system validates
            the configuration and creates the new role.
          </p>
          <StepImage src={roleStep6Img} alt="Step 6 – Save the Role" />

          <SubHeading>Validation Rules</SubHeading>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            The following validations are performed before saving:
          </p>
          <ul className="grid sm:grid-cols-2 gap-2">
            {[
              "Role Name must be unique.",
              "Role Name is mandatory.",
              "At least one monitoring product should be assigned.",
              "Duplicate resource assignments are not permitted.",
              "Assigned resources must belong to the selected technology.",
            ].map(v => (
              <li key={v} className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400">
                <FiCheckCircle className="text-primary shrink-0" /> {v}
              </li>
            ))}
          </ul>

          <SubHeading>Notes</SubHeading>
          <NoteBox tone="amber" title="Important">A single role can be assigned to multiple users.</NoteBox>
          <NoteBox tone="slate" title="Recommendation">
            Grant only the permissions required to perform the user's responsibilities. Following the Principle of
            Least Privilege improves system security.
          </NoteBox>
          <NoteBox tone="slate" title="Note">
            Any modifications made to an existing role automatically affect all users assigned to that role after
            their next login.
          </NoteBox>

          <SubHeading>Expected Result</SubHeading>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">After successfully saving the role:</p>
          <ul className="space-y-2">
            <BulletItem>The role is displayed in the Role Management list.</BulletItem>
            <BulletItem>Assigned monitoring products are saved.</BulletItem>
            <BulletItem>Feature permissions are stored.</BulletItem>
            <BulletItem>Resource mappings are associated with the role.</BulletItem>
            <BulletItem>The role becomes available during User Creation.</BulletItem>
          </ul>

          <SubHeading>Next Step</SubHeading>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            Proceed to Step 3 – Create User to assign the newly created role to a user.
          </p>
        </section>
      )}

      {/* ══════════════ STEP 3 – CREATE USER ══════════════ */}
      {showSection("User") && (
        <section className="space-y-6" style={{ animation: "fadeIn 0.3s ease" }} id="user">
          <SectionHeading icon={<MdPerson className="text-xl" />} label="Step 3 – Create User" id="create-user" />

          <SubHeading>Overview</SubHeading>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            A User represents an individual who is authorized to access the Netraa APM platform.
          </p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            User creation is the final step in the RBAC configuration process. During this step, the administrator
            associates the user with both a Client and a Role.
          </p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            The assigned Client determines the organizational context (tenant) to which the user belongs, while the
            assigned Role determines the user's permissions, navigation menu, monitoring products, dashboards, and
            resource visibility.
          </p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            Only after both the Client and Role are assigned can a user successfully access the platform with the
            intended permissions.
          </p>

          <SubHeading>Prerequisites</SubHeading>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            Before creating a user, ensure the following have already been completed:
          </p>
          <ul className="space-y-2">
            <BulletItem>Client has been created.</BulletItem>
            <BulletItem>Role has been created.</BulletItem>
            <BulletItem>Administrator access is available.</BulletItem>
            <BulletItem>User information has been collected.</BulletItem>
          </ul>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">Required information includes:</p>
          <ul className="space-y-2">
            <BulletItem>Username</BulletItem>
            <BulletItem>Full Name</BulletItem>
            <BulletItem>Email Address</BulletItem>
            <BulletItem>Mobile Number</BulletItem>
            <BulletItem>Authentication Type</BulletItem>
            <BulletItem>User Type</BulletItem>
          </ul>

          <NoteBox tone="slate" title="Navigation">
            Navigate to: Admin Configuration → User Management → Add User
          </NoteBox>

          <SubHeading>Procedure</SubHeading>

          <p className="font-semibold text-slate-800 dark:text-slate-200">Step 1: Open User Management</p>
          <ol className="space-y-3">
            <StepItem num={1}>Log in to Netraa APM using an administrator account.</StepItem>
            <StepItem num={2}>Navigate to Admin Configuration.</StepItem>
            <StepItem num={3}>Select User Management.</StepItem>
            <StepItem num={4}>Click Create User.</StepItem>
          </ol>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">The User Creation page opens.</p>
          <StepImage src={userStep1Img} alt="Step 1 – Open User Management" />

          <p className="font-semibold text-slate-800 dark:text-slate-200">Step 2: Enter User Information</p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            Provide the user's personal information.
          </p>

          <div className="divide-y divide-slate-100 dark:divide-slate-800 rounded-xl border border-slate-200 dark:border-slate-800 overflow-hidden">
            <FieldRow field="Username" description="Unique login ID used to access Netraa APM" />
            <FieldRow field="Full Name" description="User's display name" />
            <FieldRow field="Email Address" description="Used for notifications and password recovery" />
            <FieldRow field="Mobile Number" description="Contact number" />
            <FieldRow field="Description" description="Optional information about the user" />
          </div>
          {/* <StepImage src={userStep2Img} alt="Step 2 – Enter User Information" /> */}

          <p className="font-semibold text-slate-800 dark:text-slate-200">Step 3: Configure Account Settings</p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            Configure the authentication settings. Select:
          </p>
          <ul className="space-y-2">
            <BulletItem>Authentication Type</BulletItem>
            <BulletItem>User Type</BulletItem>
            <BulletItem>Account Status</BulletItem>
          </ul>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            These settings determine how the user authenticates and whether the account is active.
          </p>
          <StepImage src={userStep3Img} alt="Step 3 – Configure Account Settings" />

          <p className="font-semibold text-slate-800 dark:text-slate-200">Step 4: Assign Client and Role</p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            This is the most important step of the configuration process. Select the appropriate Client. Once a Client
            is selected, the system automatically filters and displays the Roles available for that Client. Next,
            select the required Role. The selected Role determines:
          </p>
          <ul className="space-y-2">
            <BulletItem>Accessible dashboards</BulletItem>
            <BulletItem>Monitoring products</BulletItem>
            <BulletItem>Feature components</BulletItem>
            <BulletItem>Infrastructure resources</BulletItem>
            <BulletItem>Applications</BulletItem>
            <BulletItem>Hosts</BulletItem>
            <BulletItem>Services</BulletItem>
            <BulletItem>Databases</BulletItem>
            <BulletItem>Administrative permissions</BulletItem>
          </ul>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            Configure the session timeout value if required.
          </p>
          {/* <StepImage src={userStep4Img} alt="Step 4 – Assign Client and Role" /> */}

          <p className="font-semibold text-slate-800 dark:text-slate-200">Step 5: Save the User</p>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            Review all entered information. Click Create User. The system validates the configuration and creates the
            user account.
          </p>
          <StepImage src={userStep5Img} alt="Step 5 – Save the User" />

          <SubHeading>Validation Rules</SubHeading>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            The following validations are performed before saving:
          </p>
          <ul className="grid sm:grid-cols-2 gap-2">
            {[
              "Username must be unique.",
              "Client selection is mandatory.",
              "Role selection is mandatory.",
              "Email must be valid.",
              "Mobile Number must contain only numeric values.",
              "Mandatory fields cannot be left blank.",
            ].map(v => (
              <li key={v} className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400">
                <FiCheckCircle className="text-primary shrink-0" /> {v}
              </li>
            ))}
          </ul>

          <SubHeading>Notes</SubHeading>
          <NoteBox tone="amber" title="Important">A user cannot exist without a Client assignment.</NoteBox>
          <NoteBox tone="amber" title="Important">A user's permissions are inherited entirely from the assigned Role.</NoteBox>
          <NoteBox tone="slate" title="Recommendation">
            Assign only the minimum permissions required for the user's responsibilities.
          </NoteBox>

          <SubHeading>Expected Result</SubHeading>
          <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
            After successfully creating the user:
          </p>
          <ul className="space-y-2">
            <BulletItem>The user appears in the User Management page.</BulletItem>
            <BulletItem>The account becomes active.</BulletItem>
            <BulletItem>The user can authenticate using the configured credentials.</BulletItem>
            <BulletItem>The navigation menu is generated dynamically according to the assigned Role.</BulletItem>
            <BulletItem>Access to monitoring data is restricted to the assigned Client.</BulletItem>
            <BulletItem>Resource visibility is controlled according to the configured Role permissions.</BulletItem>
          </ul>
        </section>
      )}

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </main>
  );
}

export default AdminOnboardingGuide;